// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
//import Antd from 'ant-design-vue';
//import 'ant-design-vue/dist/antd.css';

//Vue.use(VueAxios, axios)
//Vue.use(Antd);

// import configService from '@/common/service/config.service.js'
import ElementUI from 'element-ui';
import '@/utils/global'//全局
import './promission'//这里进行路由后台获取的模拟
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss' // global css
import './assets/css/font.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
 import 'swiper/dist/css/swiper.css'//'swiper/css/swiper.css'
import '@/styles/video.css' // global css
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import animated from 'animate.css'

Vue.use(animated)
Vue.use(VideoPlayer);

console.log(process.env.NODE_ENV)

Vue.config.productionTip = false
Vue.use(ElementUI)
//首页滚屏Swiper 和其他轮播
 Vue.use(VueAwesomeSwiper)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js